import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';
import { Id, InboundId, RefDataProductInboundContributorCurrentForm } from './refdata-product-inbound-contributor-current.form';

export class RefDataProductInboundContributorForm extends CerFormAdapter {

  override view(): CerFormView {
    return RefDataProductInboundContributorForm.contributorView(false);
  }

  public static contributorView(linked: boolean): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'titel-bidragsydere-bop', dataApiName: 'RefDataProductInboundContributor',
        text: 'Titel bidragsydere historik BOP', textSingular: 'Titel bidragsyder historik BOP',
        titleFields: ['keyBeforeName', 'keyName'],
        primaryKey: 'id', baseFields: ['id'],
        parentForeignKey: (linked ? InboundId : null), parentPrimaryKey: (linked ? Id : null),
        allowEdit: false, allowCreate: false, allowDelete: false,
        navigations: [
          { link: 'nav', foreignKey: { parentEntity: 'RefDataProductInbound', parentColumn: Id, column: InboundId } }
        ]

      },
      fieldMetadata: RefDataProductInboundContributorCurrentForm.fieldMetadata(linked)
    });
  }
}

